const formSubmittedPageTranslations = {
  title: "Get Ready To Transform",
  description: "Your fitness journey begins in:",
  cta: "Watch Videos",
};

export default formSubmittedPageTranslations;
